import { ArrowLeft } from "lucide-react";
import { Link, Outlet } from "react-router";

import { LogoWithTitle } from "@/site/ui/logo-with-title";
import { ThemeControl } from "@/site/ui/theme-control";

import { AuthStory } from "./ui/auth-story";

// Give authentication enough product context to feel safe and intentional.
export default function AuthLayout() {
  return (
    <div className="grid min-h-dvh lg:grid-cols-[1.02fr_0.98fr]">
      <aside className="bg-primary text-primary-foreground hidden min-h-dvh flex-col justify-between p-10 lg:flex xl:p-16">
        <LogoWithTitle linkTo="/" />
        <AuthStory />
        <p className="text-sm opacity-65">Make sense of every cent.</p>
      </aside>

      <main className="relative flex min-h-dvh items-center justify-center px-5 py-24 sm:px-8">
        <div className="absolute top-5 left-5 lg:hidden">
          <LogoWithTitle linkTo="/" />
        </div>
        <div className="absolute top-5 right-5">
          <ThemeControl />
        </div>

        <div className="w-full max-w-md">
          <Link
            className="text-muted-foreground hover:text-foreground mb-8 inline-flex items-center gap-2 text-sm"
            to="/"
          >
            <ArrowLeft className="size-4" />
            Back home
          </Link>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
